import UserMessage from "src/components/shared/userMessage/userMessage";
import { Row, Text } from "@amzn/meridian";
import BotMessage from "src/components/shared/botMessage/botMessage";
import { ExceptionTurn } from "src/components/pages/admin/types";

interface ChatExceptionProps {
  turn: ExceptionTurn;
  userAlias: string;
}

interface renderMessageProps {
  color: "error" | "warning";
  title: string | React.ReactNode;
  content: string;
}

const renderMessage = ({ color, title, content }: renderMessageProps) => {
  return (
    <>
      <Row>
        <Text color={color} type="h200">
          {title}
        </Text>
      </Row>
      <Text>{content}</Text>
    </>
  );
};

const ChatExceptionView = ({ turn, userAlias }: ChatExceptionProps) => {
  return (
    <>
      <UserMessage
        maxWidth="525px"
        alias={userAlias}
        className="chat-messages__message"
      >
        {turn.userRequest}
      </UserMessage>

      <BotMessage className="chat-messages__message" maxWidth="525px">
        {turn.isTimeoutRisk
          ? renderMessage({
              color: "error",
              title: (
                <>
                  Response Timeout (not shown to user){" "}
                  <span style={{ marginLeft: "6px" }}>
                    {" "}
                    {Math.round(turn.processingTimeMs / 1000)}s
                  </span>
                </>
              ),
              content: "This message took more than 29s to respond.",
            })
          : renderMessage({
              color: "error",
              title: "SAFER Exception (not shown to user)",
              content: turn.exceptionMessage,
            })}

        {/* if safer response exists */}
        {turn.systemResponse != null &&
          renderMessage({
            color: "warning",
            title: "LLM Response (not shown to user)",
            content: turn.systemResponse,
          })}
      </BotMessage>
    </>
  );
};

export default ChatExceptionView;
